import { Badge, Box, Typography, useTheme, Chip } from '@mui/material';

interface RoomMainInfoProps {
  name: string;
  status: string;
  statusLabel: string;
  statusColor: any;
  tenantName?: string;
  createdAt?: string;
  id: string;
  virtualKey?: boolean;
}

export function RoomMainInfo({ name, status, statusLabel, statusColor, tenantName, createdAt, id, virtualKey }: RoomMainInfoProps) {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, background: '#F8FAFF', borderRadius: 3, p: 2 }}>
      <Box sx={{ width: 48, height: 48, borderRadius: '50%', background: theme.palette.primary.main, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* Ícone pode ser passado por prop se desejar */}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography fontWeight={700} fontSize={22} color="#23272E">
          {name}
          <Box component="span" sx={{ ml: 2, verticalAlign: 'middle' }}>
            <Badge color={statusColor}>{statusLabel}</Badge>
          </Box>
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
          <Typography fontSize={15} color="#6B7280">
            {tenantName}
          </Typography>
          <Chip
            label={virtualKey ? 'Chave Virtual Habilitada' : 'Chave Virtual Desabilitada'}
            color={virtualKey ? 'success' : 'default'}
            size="small"
            variant="outlined"
          />
        </Box>
        <Typography fontSize={13} color="#9CA3AF">
          ID: {id}
        </Typography>
      </Box>
    </Box>
  );
} 